/* jshint esversion: 6 */
/* jshint ignore:start */
import { createContext, useEffect, useState } from 'react';
import CryptoJS from "crypto-js";

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const ApiBasUrl = "https://gomechpro.cscodetech.com/api";
    const ImgBasUrl = "https://gomechpro.cscodetech.com/";
    const paymentBaseURL = "https://gomechpro.cscodetech.com/";

    const OneSignalUserAppId = "1ba1f675-0288-476a-a335-54b61a28917f";
    const OneSignalUserKey = "os_v2_app_b5tzmg3uhfd5jakoho4rr5s3xdylvgty6n2ufzfcxcakvwnrjxe2koz2heuyuvmcijgigehr5quaecoy7345gxs5jfcj6h3sagbovcq";
    const OneSignalStoreAppId = "0f67961b-7439-47d4-814e-3bb918f65bb8";

    const SECRET_KEY = "CSCODETECH@412";

    const [showloginpage, setShowLoginPage] = useState(false);
    const [showsignuppage, setShowSignupPage] = useState(false);
    const [showselectcarpage, setShowSelectCarPage] = useState(false);
    const [islogin, setIsLogin] = useState("");
    const [selectmodel, setSelectModel] = useState("");
    const [callapi, setCallApi] = useState("");
    const [totalcart, setTotalCart] = useState(0);
    const [paymentloading, setPaymentLoading] = useState(false);
    const [paymentRes, setPaymentRes] = useState();
    const [transactionId, setTransactionId] = useState();
    const [guestmooddata, setGuestMoodeData] = useState("");
    const [isguestmode, setIsGuestMood] = useState(false);
    const [cartstatus, setCartStatus] = useState(0);
    const [MapKey, setMapKey] = useState("");
    const [isInstallable, setIsInstallable] = useState(false);


    useEffect(() => {
        const LocalCart = localStorage.getItem("Cartitem");
        if (LocalCart) {
            const bytes = CryptoJS.AES.decrypt(LocalCart, SECRET_KEY);
            const { cartitem, packagecartitem } = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            const combineLength = [...packagecartitem, ...cartitem];
            setTotalCart(combineLength.length);
        }
    }, []);

    const value = {
        showloginpage, setShowLoginPage,
        showsignuppage, setShowSignupPage,
        showselectcarpage, setShowSelectCarPage,
        islogin, setIsLogin,
        selectmodel, setSelectModel,
        callapi, setCallApi,
        totalcart, setTotalCart,
        paymentloading, setPaymentLoading,
        paymentRes, setPaymentRes,
        transactionId, setTransactionId,
        guestmooddata, setGuestMoodeData,
        isguestmode, setIsGuestMood,
        cartstatus, setCartStatus,
        MapKey, setMapKey,
        isInstallable, setIsInstallable,
        ApiBasUrl, ImgBasUrl,SECRET_KEY,
        paymentBaseURL, OneSignalUserAppId,
        OneSignalUserKey, OneSignalStoreAppId
    };

    return (
        <MyContext.Provider value={value}>
            {children}
        </MyContext.Provider>
    )
}

export { MyProvider, MyContext }
/* jshint ignore:end */